"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CardDate = exports.CardTitle = exports.CardImg = exports.CardImgWrapper = exports.CardContent = exports.Card = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var Card = _styledComponents["default"].div.withConfig({
  displayName: "style__Card"
})(["box-shadow:-2px 0 8px rgba(0,0,0,0.1);padding:0.5rem;&:hover{box-shadow:-4px 0 16px rgba(0,0,0,0.1);}"]);

exports.Card = Card;

var CardContent = _styledComponents["default"].div.withConfig({
  displayName: "style__CardContent"
})(["padding-right:2.5rem;margin-bottom:1rem;height:4rem;word-break:break-all;"]);

exports.CardContent = CardContent;

var CardImgWrapper = _styledComponents["default"].div.withConfig({
  displayName: "style__CardImgWrapper"
})(["position:relative;padding-top:60%;"]);

exports.CardImgWrapper = CardImgWrapper;

var CardImg = _styledComponents["default"].img.withConfig({
  displayName: "style__CardImg"
})(["position:absolute;top:0;bottom:0;right:0;left:0;width:100%;height:100%;display:block;"]);

exports.CardImg = CardImg;

var CardTitle = _styledComponents["default"].div.withConfig({
  displayName: "style__CardTitle"
})(["margin-bottom:0.25rem;font-size:1rem;"]);

exports.CardTitle = CardTitle;

var CardDate = _styledComponents["default"].div.withConfig({
  displayName: "style__CardDate"
})(["font-size:0.75rem;color:", ";"], function (a) {
  return a.theme.colors && a.theme.colors.black && a.theme.colors.black.main;
});

exports.CardDate = CardDate;